





















































































import CookieMethods from '@/mixins/CookieMethods.vue'
import { Component, Mixins, Vue, Ref } from 'vue-property-decorator'
import InputField from '@/components/marker/atoms/InputField.vue'
import CardBase from '@/components/marker/atoms/CardBase.vue'
import SelectBase, { SelectOption } from '@/components/common/atoms/SelectBase.vue'
import ModalBase from '@/components/common/molecules/ModalBase.vue'
import ReserveQuestionMarkerListApis, {
  ReserveQuestionMarkerData,
} from '@/mixins/requests/marker/ReserveQuestionMarkerListApis.vue'
import QuestionMarkerAssignmentListApis, {
  CONVERT_ANSWER_FORMAT_TO_TEXT,
  QuestionMarkerAssignmentDetailData,
} from '@/mixins/requests/marker/QuestionMarkerAssignmentListApis.vue'

@Component({
  components: {
    InputField,
    CardBase,
    SelectBase,
    ModalBase,
  },
})
export default class Marking extends Mixins(
  ReserveQuestionMarkerListApis,
  QuestionMarkerAssignmentListApis,
  CookieMethods
) {
  /** 設問表示モーダル */
  @Ref() questionModal!: ModalBase
  /** 設問画像表示領域要素 */
  @Ref() questionImageBlock!: HTMLElement

  /** 縦表示コンテンツフラグ */
  private showVerticalContent = false

  private headers = [
    { text: '解答', value: 'answer' },
    { text: '採点', value: 'mark' },
    { text: '点数', value: 'score' },
  ]

  private items: ReserveQuestionMarkerData[] = []
  private filteredItems: ReserveQuestionMarkerData[] = []
  private questionMarkerAssignmentDetailData: QuestionMarkerAssignmentDetailData | null = null
  private markOptions: SelectOption[] = [
    { text: '-', value: '採点中' },
    { text: '◯', value: '◯' },
    { text: '×', value: '×' },
    { text: '△', value: '△' },
  ]

  get validationMessage(): string {
    if (!this.questionMarkerAssignmentDetailData) return ''
    return `点数は${this.questionMarkerAssignmentDetailData.allocation}点以下でつけて下さい。`
  }

  // 採点済みの設問数
  get scoredNum(): number {
    return this.items.filter((item) => item.correctText !== '採点中').length
  }

  // 問題タイプの表示
  get displayAnswerFormat(): string {
    if (!this.questionMarkerAssignmentDetailData) return ''
    return CONVERT_ANSWER_FORMAT_TO_TEXT[this.questionMarkerAssignmentDetailData.answerFormat]
  }

  private async mounted() {
    Vue.prototype.$loading.start()
    try {
      if (
        typeof this.$route.query.questionId === 'string' &&
        typeof this.$route.query.questionMarkerAssignmentId === 'string'
      ) {
        this.items = await this.searchReserveQuestionMarkers({
          questionId: parseInt(this.$route.query.questionId),
          questionMarkerAssignmentId: parseInt(this.$route.query.questionMarkerAssignmentId),
        })
        this.filteredItems = this.items
        this.questionMarkerAssignmentDetailData = await this.getQuestionMarkerAssignment({
          id: parseInt(this.$route.query.questionMarkerAssignmentId),
        })
        // 縦表示コンテンツか判定
        this.showVerticalContent =
          this.questionMarkerAssignmentDetailData.subjectCode === 'ko' &&
          !this.questionMarkerAssignmentDetailData.isKoHorizontal
      }
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  private async save() {
    // 採点済みの設問
    const markedItems = this.items.filter((item) => item.correct !== 'scoring')

    // 採点が「△」で 点数未入力のもの もしくは 点数入力が数値じゃないもの もしくは 点数が配点より高いもの を抽出
    const correctErrors = markedItems.filter((item) => {
      if (!this.questionMarkerAssignmentDetailData) return
      if (item.correct == 2 && isNaN(parseInt(item.score as string))) return item
      else if (item.correct == 2 && parseInt(item.score as string) > this.questionMarkerAssignmentDetailData.allocation)
        return item
    })
    if (correctErrors.length) {
      return alert('「△」で採点した解答で点数の入力が不正のものがあります。')
    }
    Vue.prototype.$loading.start()
    try {
      if (typeof this.$route.query.questionMarkerAssignmentId === 'string') {
        await this.saveManualScore({
          questionMarkerAssignmentId: parseInt(this.$route.query.questionMarkerAssignmentId),
          resultQuestions: markedItems.map((item) => {
            return {
              id: item.resultQuestionId,
              correctText: item.correctText,
              correct: item.correct as number,
              score: typeof item.score === 'string' ? parseInt(item.score) : item.score,
            }
          }),
        })
      }
      this.$router.go(-1)
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  private onMark(item: ReserveQuestionMarkerData): void {
    if (!this.questionMarkerAssignmentDetailData) return
    if (item.correctText === '◯') {
      item.score = this.questionMarkerAssignmentDetailData.allocation.toString()
      item.correct = 1
    } else if (item.correctText === '×') {
      item.score = '0'
      item.correct = 0
    } else if (item.correctText === '△') {
      item.score = ''
      item.correct = 2
    } else {
      item.score = ''
      item.correct = 9
    }
  }

  private filtering(target: string): void {
    this.filteredItems = this.items.filter((item) => item.correctText === target)
  }

  /** 設問画像読み込み完了時の処理 */
  private async loadedQuestionImage(): Promise<void> {
    // 縦表示コンテンツであれば右端までスクロール
    if (this.showVerticalContent) this.questionImageBlock.scrollTo({ left: this.questionImageBlock.scrollWidth })
  }

  /** 設問画像表示用（縦方向用）Class付与処理 */
  private get questionImageClassObject(): { [key: string]: boolean } {
    return {
      'question-image--vertical': this.showVerticalContent,
    }
  }

  /** 設問画像モーダル表示 */
  private showQuestionModal(): void {
    this.questionModal.show()
  }
}
